
import { NATURE_SOUND_COVER_IMAGE_RATIO } from "@/appSettings";
import CreateNatureSoundViewModel from "@/models/natureSound/createNatureSoundViewModel";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class PageCreateNatureSoundComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  //   currentAudio: MusicAudioViewModel = null;
  coverImageRatio = NATURE_SOUND_COVER_IMAGE_RATIO;
  get title(): string {
    return this.id
      ? "Редактирование звуков природы"
      : "Добавление звуков природы";
  }
  get id(): string {
    const routeId = this.$route.params.id;
    return routeId ? routeId : "";
  }
  vm: CreateNatureSoundViewModel = new CreateNatureSoundViewModel();
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    var result = await this.$api.BackgroundFileService.getDetailAsync(
      this.id + ""
    );
    this.vm.fromServerModel(result);
    this.isLoading = false;
  }
  async save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.BackgroundFileService.addAsync(request);
    if (res) {
      this.$dialog.success("Звуки природы успешно обновлены");
      this.$router.back();
    }
    this.isLoading = false;
  }

  audioChanged(file: File) {
    this.vm.audio.audioFile = file;
  }

  // audioChanged(file: File) {
  //   if (file) {
  //     this.vm.audio.audioFile = file;
  //   } else {
  //     this.vm.audio = null;
  //   }
  // if (this.audioAddMode == "edit") {
  //   Object.assign(this.vm.audio, audio);
  // } else if (this.audioAddMode == "add") {
  //   this.vm.audios.push(audio);
  // }
  // this.currentAudio == null;
  // }
  // audioAddMode: "edit" | "add" | null = null;
  // startAddAudio() {
  //   const audio = new MusicAudioViewModel();
  //   audio.initLanguages(this.languages);
  //   this.currentAudio = audio;
  //   this.audioAddMode = "add";
  // }
  // startEditAudio(item: MusicAudioViewModel) {
  //   this.currentAudio = item;
  //   this.audioAddMode = "edit";
  // }

  deleteAudio() {
    this.vm.audio.audioFile = null;
    this.vm.audio.audioUrl = null;
    // this.vm.audio.base64File = null;
  }
}
